import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
const MaterialCalculator = React.lazy(() => import('./MaterialCalculator'));

// ── FAQ DATA ──────────────────────────────────────────────────────────────────

const FAQ_SHORT = [
  { q: 'Що таке LIHTAR і для кого він?', a: 'LIHTAR — хмарна платформа для виконробів, будівельників і ремонтних компаній. Кошториси, бюджет, графік робіт і спілкування з клієнтом — в одному місці, з телефону або комп\'ютера.' },
  { q: 'Чи є безкоштовна версія?', a: 'Так. FREE тариф: 1 об\'єкт, до 50 позицій у звіті, 3 шаблони, 1 PDF на місяць. Цього достатньо щоб познайомитися з платформою.' },
  { q: 'Що таке 14-денний PRO-тріал?', a: 'Після реєстрації кожен новий користувач автоматично отримує повний PRO-доступ на 14 днів — без введення картки.' },
  { q: 'Що таке AI-імпорт і як він працює?', a: 'Вставте текст з месенджера, Excel або PDF — AI автоматично розпізнає позиції, кількість і ціни. Займає 5–10 секунд замість години ручного введення. Голосові повідомлення не підтримуються.' },
  { q: 'Чим відрізняється «Робоча ціна» від «Клієнтської ціни»?', a: 'Робоча — ваша собівартість. Клієнтська = робоча × (1 + націнка%). LIHTAR рахує автоматично. Клієнт бачить тільки клієнтську ціну — ваш прибуток залишається прихованим.' },
  { q: 'Як поділитися кошторисом з клієнтом?', a: 'Натисніть іконку посилання на картці об\'єкта → скопіюйте унікальне посилання → надішліть клієнту. Клієнт відкриває без реєстрації та бачить зручно відформатований кошторис.' },
  { q: 'Що таке калькулятор матеріалів?', a: 'Інструмент для точного розрахунку будматеріалів. Вкажіть тип роботи (стяжка, штукатурка, перегородки тощо) і розміри — система порахує кількість мішків, рулонів або упаковок.' },
  { q: 'Скільки коштує PRO?', a: '300 грн на місяць. Оплата карткою Visa/Mastercard через Monobank Acquiring. Перші 14 днів — безкоштовно після реєстрації, без картки.' },
  { q: 'Що входить у PRO?', a: 'Необмежена кількість об\'єктів і позицій, PDF без вотермарку, брендування, AI-імпорт, тендери, посилання для клієнта, чат, Excel-експорт, Google Drive, партнерські комісії.' },
  { q: 'LIHTAR працює на телефоні?', a: 'Так, повністю адаптований для мобільних. Відкривайте lihtar.app у браузері — весь функціонал доступний. Можна додати на головний екран як додаток (PWA).' },
  { q: 'Де зберігаються мої дані?', a: 'В хмарі (Supabase) — захищений PostgreSQL-сервер з Row Level Security. Ви не втратите нічого при зміні пристрою або очищенні браузера.' },
  { q: 'Що буде з даними при переході з PRO на FREE?', a: 'Всі дані зберігаються. Нові об\'єкти не можна буде створювати понад ліміт FREE, але існуючі залишаються повністю доступними.' },
  { q: 'Як зв\'язатися з командою LIHTAR?', a: 'Telegram: t.me/lihtar_app — публікуємо оновлення, відповідаємо на питання та збираємо побажання.' },
  { q: 'Де дивитися навчальні відео?', a: 'TikTok та Instagram @lihtar.app. В додатку є інтерактивний тур — натисніть «Почати тур» на головному екрані.' },
  { q: 'Як додати LIHTAR на головний екран телефону?', a: 'Android (Chrome): меню → «Додати на головний екран». iPhone (Safari): кнопка «Поділитися» → «На екран Початок». Після цього LIHTAR відкривається як звичайний додаток.' },
];

const FAQ_FULL = [
  { cat: 'Початок роботи', items: [
    { q: 'Що таке LIHTAR і для кого він?', a: 'LIHTAR — хмарна платформа для виконробів, будівельників і ремонтних компаній. Дозволяє вести кошториси, контролювати бюджет, планувати роботи та спілкуватися з клієнтом — все в одному місці, з телефону або комп\'ютера.' },
    { q: 'Як зареєструватися?', a: 'Натисніть «Розпочати безкоштовно» → «Увійти через Google» — реєстрація займає 10 секунд. Або введіть email і пароль.' },
    { q: 'Чи є безкоштовна версія?', a: 'Так. FREE: 1 об\'єкт, до 50 позицій у звіті, 3 шаблони, 1 PDF на місяць. Назавжди безкоштовно.' },
    { q: 'Що таке 14-денний PRO-тріал?', a: 'Після реєстрації — повний PRO на 14 днів без картки. Після закінчення обираєте FREE або PRO.' },
    { q: 'Як працює LIHTAR на телефоні?', a: 'Повністю адаптований. Відкривайте lihtar.app у браузері або додайте на головний екран (PWA).' },
    { q: 'Де зберігаються мої дані?', a: 'В хмарі (Supabase) — захищений PostgreSQL-сервер із Row Level Security.' },
  ]},
  { cat: 'Об\'єкти і кошторис', items: [
    { q: 'Як змінити статус об\'єкта?', a: 'На екрані кошторисів → «Інформація про об\'єкт» → «Статус». Кнопки на картці об\'єкта статус не змінюють.' },
    { q: 'Що таке «Попередній кошторис» і «Звіт»?', a: '«Попередній» — план і орієнтовна вартість для клієнта на початку. «Звіт» — фактично виконані роботи з реальними цінами.' },
    { q: 'Як додати позицію?', a: 'Натисніть «+ Додати позицію» всередині розділу. Кнопка FAB «+» внизу екрану — додає розділ, а не позицію.' },
    { q: 'Чим відрізняється «Робоча ціна» від «Клієнтської ціни»?', a: 'Робоча — собівартість. Клієнтська = робоча × (1 + націнка%). LIHTAR рахує автоматично.' },
    { q: 'Що таке АТС?', a: 'Адміністративно-технічний супровід — відсоток за організацію робіт. Налаштовується для кожного розділу, типово 10–20%.' },
    { q: 'Як приховати позицію від клієнта?', a: 'Натисніть іконку ока поряд з позицією — вона залишиться у вашому обліку, але не відображатиметься клієнту по посиланню.' },
    { q: 'Як заблокувати ціну?', a: 'Натисніть іконку замка — клієнтська ціна не змінюватиметься при зміні відсотка націнки.' },
  ]},
  { cat: 'AI-імпорт', items: [
    { q: 'Що таке AI-імпорт і як він працює?', a: 'Вставте текст у будь-якому форматі — система розпізнає позиції, кількість та ціни за 5–10 секунд. Голосові повідомлення не підтримуються.' },
    { q: 'Які формати розпізнає імпорт?', a: 'PDF, Excel (.xlsx, .xls), Word (.docx), CSV та звичайний текст з месенджера.' },
    { q: 'Що робити якщо імпорт розпізнав неправильно?', a: 'Перед вставкою показується таблиця розпізнаних позицій. Зніміть галочку з неправильних або відредагуйте.' },
    { q: 'Чи можна зберегти результат імпорту як шаблон?', a: 'Так — кнопка «Зберегти як шаблон» у нижній частині вікна імпорту.' },
  ]},
  { cat: 'Шаблони та довідник', items: [
    { q: 'Навіщо потрібні шаблони?', a: 'Збережені набори типових робіт. Замість повторного введення — застосовуєте одним кліком до нового кошторису.' },
    { q: 'Як створити шаблон?', a: 'Вкладка «Шаблони» → кнопка «+» → введіть назву → додайте розділи та позиції.' },
    { q: 'Скільки шаблонів можна зберігати?', a: 'FREE — 3 шаблони. PRO — необмежено.' },
    { q: 'Що таке «Довідник цін»?', a: 'Особистий прайс-лист. При наборі позиції в кошторисі — автоматичні підказки з вашими та ринковими цінами.' },
    { q: 'Що таке ринковий прайс-лист?', a: '783 актуальних ринкових позиції по Україні. Оновлюється щомісяця автоматично.' },
    { q: 'Як поділитися довідником з клієнтом?', a: 'В довіднику є унікальне посилання — клієнт відкриває ваш прайс без реєстрації. PRO: PDF-версія з вашим брендингом.' },
  ]},
  { cat: 'Клієнтський доступ', items: [
    { q: 'Як поділитися кошторисом з клієнтом?', a: 'Натисніть іконку посилання → скопіюйте → надішліть. Клієнт відкриває без реєстрації.' },
    { q: 'Що бачить клієнт?', a: 'Кошторис з клієнтськими цінами. Робоча ціна і прибуток — невидимі. Приховані позиції також не відображаються.' },
    { q: 'Як спілкуватися з клієнтом?', a: 'Вбудований чат. Клієнт пише зі свого посилання — ви відповідаєте зі свого акаунту.' },
    { q: 'Як заблокувати доступ клієнта?', a: 'В налаштуваннях посилання є перемикач «Активне/Неактивне».' },
  ]},
  { cat: 'Бюджет і фінанси', items: [
    { q: 'Що таке «Бюджет» в LIHTAR?', a: 'Розділ де ви фіксуєте фактичні витрати — накладні, чеки, оплати підрядникам. Порівнюється з кошторисом в реальному часі.' },
    { q: 'Що таке «Прогрес проєкту»?', a: 'Показує відсоток виконання, витрачену та отриману суму, баланс і вартість за м².' },
    { q: 'Що таке «Оплати»?', a: 'Фіксуєте надходження від клієнта — дату і суму. LIHTAR показує залишок до сплати.' },
  ]},
  { cat: 'Графік робіт (Gantt)', items: [
    { q: 'Що таке Gantt в LIHTAR?', a: 'Таймлайн проєкту з етапами, задачами і підрядниками. Можна прив\'язати позиції кошторису до задач.' },
    { q: 'Клієнт може бачити графік?', a: 'Так — якщо ви відкрили доступ по посиланню, клієнт бачить Gantt в режимі перегляду.' },
    { q: 'Як призначити підрядника на задачу?', a: 'В редакторі задачі → «Підрядник» → оберіть зі списку ваших підрядників.' },
  ]},
  { cat: 'Тендери', items: [
    { q: 'Що таке «Тендер» в LIHTAR?', a: 'Ви публікуєте кошторис або шаблон — підрядники подають свої ціни. Закритий тип: тільки запрошені. Відкритий: будь-який підрядник.' },
    { q: 'Як створити тендер?', a: 'В AI-імпорті кнопка «Зберегти як тендер», або з редактора шаблону.' },
  ]},
  { cat: 'Калькулятор матеріалів', items: [
    { q: 'Що таке калькулятор матеріалів?', a: 'Інструмент для розрахунку кількості будматеріалів (стяжка, штукатурка, перегородки, стелі). Доступний без реєстрації за адресою lihtar.app/calculator.' },
    { q: 'Чи вставляє калькулятор позиції в кошторис?', a: 'Ні — калькулятор формує список для замовлення постачальнику. До кошторису позиції додаються вручну або через AI-імпорт.' },
  ]},
  { cat: 'Google Drive', items: [
    { q: 'Як працює Google Drive інтеграція?', a: 'При реєстрації через Google — LIHTAR автоматично створює папку LIHTAR/{Назва об\'єкта} на вашому диску. Всі завантажені файли проєкту зберігаються там.' },
    { q: 'Чи працює Drive без Google-акаунту?', a: 'Ні. Якщо реєструвались через email — файли зберігаються на сервері LIHTAR (до 10 МБ на об\'єкт).' },
  ]},
  { cat: 'PDF та експорт', items: [
    { q: 'Що можна експортувати в PDF?', a: 'Кошторис, звіти, довідник цін. FREE: 1 PDF на місяць з вотермарком. PRO: необмежено, без вотермарку, з вашим брендингом.' },
    { q: 'Що таке Excel-експорт?', a: 'Вивантаження кошторису в .xlsx файл. Доступно тільки на PRO тарифі.' },
  ]},
  { cat: 'Тариф PRO', items: [
    { q: 'Скільки коштує PRO?', a: '300 грн на місяць. Оплата карткою Visa/Mastercard через Monobank Acquiring.' },
    { q: 'Що входить у PRO?', a: 'Необмежено об\'єктів і позицій, PDF без вотермарку, брендування, AI-імпорт, тендери, чат, Excel, Google Drive, партнерські комісії.' },
    { q: 'Як перейти на PRO?', a: 'Натисніть «Перейти на PRO» у меню або при спробі скористатись PRO-функцією.' },
    { q: 'Чи можна скасувати підписку?', a: 'Так, в будь-який момент у «Налаштування» → «Підписка».' },
    { q: 'Що буде з даними при переході з PRO на FREE?', a: 'Всі дані зберігаються. Нові об\'єкти понад ліміт FREE створювати не можна, але існуючі залишаються.' },
  ]},
  { cat: 'Технічні питання', items: [
    { q: 'LIHTAR працює без інтернету?', a: 'Ні — всі дані в хмарі. Але інтерфейс швидкий навіть на мобільному інтернеті.' },
    { q: 'На яких браузерах працює?', a: 'Chrome, Safari, Firefox, Edge. Рекомендується Chrome.' },
    { q: 'Як додати LIHTAR на головний екран?', a: 'Android (Chrome): меню → «Додати на головний екран». iPhone (Safari): «Поділитися» → «На екран Початок».' },
    { q: 'Чи захищені мої дані?', a: 'Так. Row Level Security на рівні БД. UUID-токени для посилань неможливо вгадати.' },
  ]},
  { cat: 'Підтримка', items: [
    { q: 'Як зв\'язатися з командою?', a: 'Telegram: t.me/lihtar_app' },
    { q: 'Де дивитися навчальні відео?', a: 'TikTok та Instagram @lihtar.app. В додатку є інтерактивний тур — «Почати тур» на головному екрані.' },
  ]},
];

// ── FEATURES DATA ─────────────────────────────────────────────────────────────

const FEATURES = [
  {
    title: 'Кошторис з автоматичним розрахунком',
    desc: 'Додавайте розділи і позиції, вказуйте робочу ціну та націнку — клієнтська ціна і підсумки рахуються автоматично. Окремо показує матеріали, роботи, АТС і ваш прибуток.',
    points: ['Робоча ціна і клієнтська ціна окремо', 'АТС — адміністративно-технічний супровід', 'Приховати позицію від клієнта', 'Фіксована клієнтська ціна (замок)', 'До 6 звітів на одному об\'єкті'],
    img: '/screenshot-editor.webp',
  },
  {
    title: 'AI-імпорт позицій',
    desc: 'Вставте текст з месенджера, Excel або PDF — AI автоматично розпізнає позиції, кількість та ціни. Займає 5–10 секунд замість години ручного введення.',
    points: ['PDF, Excel (.xlsx), Word (.docx), CSV', 'Довільний текст: «Монтаж кондера 2шт × 3500»', 'Перевірка перед імпортом — зніміть зайве', 'Зберегти результат як шаблон або тендер'],
    img: '/screenshot-import.webp',
  },
  {
    title: 'Графік робіт — Gantt',
    desc: 'Плануйте етапи і задачі на часовій шкалі. Хто що робить і коли — без конфліктів між бригадами. Клієнт також може переглядати графік по посиланню.',
    points: ['Етапи з підзавданнями і підрядниками', 'Прогрес виконання в %', 'Прив\'язка позицій кошторису до задач', 'Клієнт бачить графік по посиланню'],
    img: '/screenshot-gantt.webp',
  },
  {
    title: 'Шаблони типових робіт',
    desc: 'Збережіть набір позицій як шаблон і застосовуйте одним кліком. «Ванна кімната під ключ», «Електрика», «Демонтаж» — не вводьте одне й те саме двічі.',
    points: ['Необмежена кількість шаблонів (PRO)', 'Застосування до кошторису одним кліком', 'Зберегти шаблон прямо з AI-імпорту', 'Тендер на основі шаблону'],
    img: '/screenshot-templates.webp',
  },
  {
    title: 'Довідник цін',
    desc: 'Особистий прайс-лист з вашими цінами і 783 ринкових позиціями. При введенні назви — автоматичні підказки. Поділіться прайс-листом з клієнтом за посиланням.',
    points: ['Автопідказки при введенні позиції', '783 ринкових цін (щомісячне оновлення)', 'Публічний прайс за унікальним посиланням', 'PDF-версія прайс-листа з вашим брендингом'],
    img: '/screenshot-directory.webp',
  },
  {
    title: 'Клієнтський доступ і чат',
    desc: 'Надішліть клієнту унікальне посилання — він бачить кошторис у зручному форматі без реєстрації. Вбудований чат замінює переписку в месенджерах.',
    points: ['Клієнт бачить тільки клієнтські ціни', 'Прихована робоча ціна і прибуток', 'Вбудований чат менеджер ↔ клієнт', 'Вимкнути доступ одним кліком'],
    img: '/screenshot-client.webp',
  },
];

// ── COMPONENT ─────────────────────────────────────────────────────────────────

const LandingPage = ({ onLogin }) => {
  // Auth state — не чіпаємо
  const [loginLoading, setLoginLoading] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showCalc, setShowCalc] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [authSuccess, setAuthSuccess] = useState('');
  const [emailLoading, setEmailLoading] = useState(false);

  // Stats state
  const [siteStats, setSiteStats] = useState({ users: '—' });

  useEffect(() => {
    supabase.from('site_stats').select('key,value').then(({ data }) => {
      if (!data) return;
      const map = Object.fromEntries(data.map(r => [r.key, r.value]));
      setSiteStats({ users: map.users || '70' });
    });
  }, []);

  // UI state
  const [activeFeature, setActiveFeature] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [openModalFaq, setOpenModalFaq] = useState(null);

  // ── Auth handlers (без змін) ───────────────────────────────────────────────

  const handleGoogleLogin = async () => {
    setLoginLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin,
          scopes: 'https://www.googleapis.com/auth/drive.file'
        },
      });
      if (error) throw error;
    } catch (err) {
      console.error('Login error:', err);
      setLoginLoading(false);
    }
  };

  const handleEmailLogin = async () => {
    if (!email || !password) { setAuthError('Заповніть всі поля'); return; }
    setEmailLoading(true); setAuthError('');
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        if (error.message.includes('Invalid login')) setAuthError('Невірний email або пароль');
        else if (error.message.includes('Email not confirmed')) setAuthError('Підтвердіть email — перевірте пошту');
        else setAuthError(error.message);
      }
    } catch (err) { setAuthError('Помилка входу'); }
    setEmailLoading(false);
  };

  const handleEmailRegister = async () => {
    if (!email || !password || !confirmPassword) { setAuthError('Заповніть всі поля'); return; }
    if (password.length < 6) { setAuthError('Пароль має бути не менше 6 символів'); return; }
    if (password !== confirmPassword) { setAuthError('Паролі не збігаються'); return; }
    setEmailLoading(true); setAuthError('');
    try {
      const { error } = await supabase.auth.signUp({
        email, password,
        options: { emailRedirectTo: window.location.origin }
      });
      if (error) {
        if (error.message.includes('already registered')) setAuthError('Цей email вже зареєстрований');
        else setAuthError(error.message);
      } else {
        setAuthSuccess('Лист підтвердження надіслано на ' + email + '. Перевірте пошту (і папку "Спам").');
      }
    } catch (err) { setAuthError('Помилка реєстрації'); }
    setEmailLoading(false);
  };

  const openAuth = (mode = 'login') => {
    setShowAuthModal(true);
    setAuthMode(mode);
    setAuthError('');
    setAuthSuccess('');
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  // ── RENDER ─────────────────────────────────────────────────────────────────

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", color: '#1a1a1a', background: '#fff' }}>
      <style>{STYLES}</style>

      {/* ── HEADER ── */}
      <header className="lp-hdr">
        <div className="lp-hdr-inner">
          <div className="lp-logo">LIHTAR</div>
          <nav className="lp-nav">
            <button className="lp-nav-btn" onClick={() => scrollTo('features')}>Можливості</button>
            <button className="lp-nav-btn" onClick={() => scrollTo('calculator')}>Калькулятор</button>
            <button className="lp-nav-btn" onClick={() => scrollTo('pricing')}>Ціни</button>
            <button className="lp-nav-btn" onClick={() => setShowFaqModal(true)}>FAQ</button>
            <a className="lp-nav-btn" href="/blog/yak-sklasty-koshtorys-na-remont-onlajn" style={{ textDecoration: 'none' }}>Блог</a>
            <a className="lp-nav-btn" href="/about" style={{ textDecoration: 'none' }}>Про сервіс</a>
          </nav>
          <button className="lp-login-btn" onClick={() => openAuth('login')} disabled={loginLoading}>
            {loginLoading ? '...' : 'Увійти'}
          </button>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="lp-hero">
        <div className="lp-hero-inner">
          <div className="lp-badge">Безкоштовно · Без встановлення</div>
          <h1 className="lp-h1">
            Онлайн програма для будівельних кошторисів на <span className="lp-accent">ремонт і будівництво</span>
          </h1>
          <p className="lp-hero-sub">
            Виконроби і будівельні компанії ведуть кошториси, контролюють бюджет і спілкуються з клієнтами в одному місці. З телефону або комп'ютера.
          </p>
          <div className="lp-hero-actions">
            <button className="lp-btn-cta" onClick={() => openAuth('register')}>
              Розпочати безкоштовно
            </button>
            <button className="lp-btn-outline" onClick={() => setShowCalc(true)}>
              Калькулятор матеріалів
            </button>
          </div>
          <div className="lp-hero-note">14 днів PRO безкоштовно після реєстрації · Без картки</div>
          <img src="/hero-screenshot.webp" alt="LIHTAR — мої об'єкти" className="lp-hero-screenshot" fetchpriority="high" width="1400" height="900" />
        </div>
      </section>

      {/* ── STATS ── */}
      <section style={{ background: '#fff', borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '48px 24px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 48, flexWrap: 'wrap' }}>
            <div style={{ textAlign: 'center', minWidth: 140 }}>
              <div style={{ fontSize: 44, fontWeight: 700, color: '#163248', fontFamily: "'Archivo Black', sans-serif", lineHeight: 1 }}>800+</div>
              <div style={{ fontSize: 14, color: '#6b7280', marginTop: 8 }}>позицій у довіднику цін</div>
            </div>
            <div style={{ textAlign: 'center', minWidth: 140 }}>
              <div style={{ fontSize: 44, fontWeight: 700, color: '#163248', fontFamily: "'Archivo Black', sans-serif", lineHeight: 1 }}>80+</div>
              <div style={{ fontSize: 14, color: '#6b7280', marginTop: 8 }}>тех.карт розрахунку матеріалів</div>
            </div>
            <div style={{ textAlign: 'center', minWidth: 140 }}>
              <div style={{ fontSize: 44, fontWeight: 700, color: '#163248', fontFamily: "'Archivo Black', sans-serif", lineHeight: 1 }}>50+</div>
              <div style={{ fontSize: 14, color: '#6b7280', marginTop: 8 }}>готових шаблонів робіт</div>
            </div>
            <div style={{ textAlign: 'center', minWidth: 140 }}>
              <div style={{ fontSize: 44, fontWeight: 700, color: '#163248', fontFamily: "'Archivo Black', sans-serif", lineHeight: 1 }}>{siteStats.users}</div>
              <div style={{ fontSize: 14, color: '#6b7280', marginTop: 8 }}>виконробів</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="lp-section lp-section-gray" id="features">
        <div className="lp-inner">
          <div className="lp-section-label">Можливості</div>
          <h2 className="lp-h2" style={{ marginBottom: 16 }}>Все що потрібно для роботи на об'єкті</h2>
          <p className="lp-h2-sub">Від першого кошторису до фінального звіту — один інструмент замість десятка файлів</p>
          {FEATURES.map((f, i) => (
            <div key={i} className={`lp-feat-block${i % 2 === 1 ? ' reverse' : ''}`}>
              <div className="lp-feat-text">
                <div className="lp-feat-tag">{f.title.split(' —')[0].split(' з ')[0].split(' і ')[0]}</div>
                <h3 className="lp-feat-title">{f.title}</h3>
                <p className="lp-feat-desc">{f.desc}</p>
                <ul className="lp-feat-list">
                  {f.points.map((p, j) => (
                    <li key={j}>{p}</li>
                  ))}
                </ul>
              </div>
              <img src={f.img} alt={f.title} className="lp-feat-img" width="1400" height="900" loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      {/* ── CALCULATOR ── */}
      <section className="lp-section" id="calculator" style={{ background: '#fff' }}>
        <div className="lp-inner" style={{ textAlign: 'center' }}>
          <div style={{
            display: 'inline-block', marginBottom: 20,
            border: '1.5px solid #f97316', borderRadius: 100,
            padding: '5px 16px',
            fontSize: 11, fontWeight: 700, letterSpacing: '1px',
            color: '#f97316', textTransform: 'uppercase'
          }}>Безкоштовно · Без встановлення</div>
          <h2 className="lp-h2" style={{ margin: '0 0 12px', textAlign: 'center' }}>Калькулятор будівельних матеріалів</h2>
          <p style={{
            fontSize: 16, color: '#6b7280', margin: '0 0 32px'
          }}>Стяжка, штукатурка, перегородки, плитка та інше — введіть розміри і отримайте список матеріалів</p>
          <button onClick={() => setShowCalc(true)} style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            maxWidth: 760, margin: '0 auto',
            background: '#163248', color: '#fff',
            fontWeight: 700, fontSize: 16,
            height: 120, borderRadius: 16,
            border: 'none', cursor: 'pointer', fontFamily: 'inherit', width: '100%'
          }}>
            Порахувати матеріали
          </button>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section className="lp-section lp-section-gray" id="pricing">
        <div className="lp-inner">
          <div className="lp-section-label">Тарифи</div>
          <h2 className="lp-h2" style={{ marginBottom: 40 }}>Починайте безкоштовно</h2>
          <div className="lp-pricing-grid">
            {/* FREE */}
            <div className="lp-price-card">
              <div className="lp-price-name">FREE</div>
              <div className="lp-price-amount">0 <span>грн/міс</span></div>
              <div className="lp-price-note">Назавжди безкоштовно</div>
              <ul className="lp-price-list">
                <li>1 об'єкт</li>
                <li>До 50 позицій у звіті</li>
                <li>3 шаблони</li>
                <li>1 PDF на місяць (з вотермарком)</li>
                <li>Довідник — тільки перегляд</li>
                <li className="lp-locked">Тендери</li>
                <li className="lp-locked">AI-імпорт</li>
                <li className="lp-locked">Посилання для клієнта</li>
                <li className="lp-locked">Excel-експорт</li>
              </ul>
              <button className="lp-btn-outline-navy" onClick={() => openAuth('register')}>
                Зареєструватись
              </button>
            </div>
            {/* PRO */}
            <div className="lp-price-card lp-price-pro">
              <div className="lp-pro-badge">14 днів безкоштовно</div>
              <div className="lp-price-name">PRO</div>
              <div className="lp-price-amount">300 <span>грн/міс</span></div>
              <div className="lp-price-note">Оплата карткою Visa/Mastercard · Monobank Acquiring</div>
              <ul className="lp-price-list">
                <li className="lp-pro-item">Необмежена кількість об'єктів</li>
                <li className="lp-pro-item">Необмежені позиції і шаблони</li>
                <li className="lp-pro-item">PDF без вотермарку + брендування</li>
                <li className="lp-pro-item">AI-імпорт з PDF, Excel, тексту</li>
                <li className="lp-pro-item">Тендери і підрядники</li>
                <li className="lp-pro-item">Посилання для клієнта + чат</li>
                <li className="lp-pro-item">Excel-експорт</li>
                <li className="lp-pro-item">Google Drive інтеграція</li>
              </ul>
              <button className="lp-btn-navy" onClick={() => openAuth('register')}>
                Спробувати PRO безкоштовно
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ (on page) ── */}
      <section className="lp-section" id="faq">
        <div className="lp-inner">
          <div className="lp-section-label">Часті питання</div>
          <h2 className="lp-h2">Відповіді на головні питання</h2>
          <div className="lp-faq-list">
            {FAQ_SHORT.map((item, i) => (
              <div key={i} className={`lp-faq-item${openFaq === i ? ' open' : ''}`}>
                <button className="lp-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{item.q}</span>
                  <span className="lp-faq-arrow">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <div className="lp-faq-a">{item.a}</div>}
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <button className="lp-btn-outline-navy" onClick={() => setShowFaqModal(true)}>
              Всі питання та відповіді
            </button>
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section className="lp-cta-final">
        <h2>Готові спробувати?</h2>
        <p>Зареєструйтесь за 10 секунд — і отримайте повний доступ до всіх функцій</p>
        <button className="lp-btn-cta-white" onClick={() => openAuth('register')}>
          Розпочати безкоштовно
        </button>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-logo">LIHTAR</div>
          <div className="lp-footer-links" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <a href="https://t.me/lihtar_app" target="_blank" rel="noopener noreferrer" title="Telegram" style={{ color: '#9ca3af', transition: 'color .2s' }} onMouseEnter={e => e.currentTarget.style.color='#fff'} onMouseLeave={e => e.currentTarget.style.color='#9ca3af'}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
            </a>
            <a href="https://www.youtube.com/@LIHTARua" target="_blank" rel="noopener noreferrer" title="YouTube" style={{ color: '#9ca3af', transition: 'color .2s' }} onMouseEnter={e => e.currentTarget.style.color='#fff'} onMouseLeave={e => e.currentTarget.style.color='#9ca3af'}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="https://www.instagram.com/lihtar.app" target="_blank" rel="noopener noreferrer" title="Instagram" style={{ color: '#9ca3af', transition: 'color .2s' }} onMouseEnter={e => e.currentTarget.style.color='#fff'} onMouseLeave={e => e.currentTarget.style.color='#9ca3af'}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
            </a>
            <a href="https://www.tiktok.com/@lihtar.app" target="_blank" rel="noopener noreferrer" title="TikTok" style={{ color: '#9ca3af', transition: 'color .2s' }} onMouseEnter={e => e.currentTarget.style.color='#fff'} onMouseLeave={e => e.currentTarget.style.color='#9ca3af'}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
            </a>
          </div>
          <div className="lp-footer-copy">© {new Date().getFullYear()} LIHTAR · lihtar.app</div>
        </div>
      </footer>

      {/* ── FAQ MODAL ── */}
      {showFaqModal && (
        <div
          className="lp-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setShowFaqModal(false); }}
        >
          <div className="lp-modal-box">
            <div className="lp-modal-hdr">
              <span style={{ fontSize: 18, fontWeight: 700, color: '#163248' }}>Питання та відповіді</span>
              <button className="lp-modal-close" onClick={() => setShowFaqModal(false)}>✕</button>
            </div>
            <div className="lp-modal-body">
              {FAQ_FULL.map((cat, ci) => (
                <div key={ci}>
                  <div className="lp-modal-cat">{cat.cat}</div>
                  {cat.items.map((item, ii) => {
                    const key = `${ci}-${ii}`;
                    return (
                      <div key={ii} className={`lp-faq-item${openModalFaq === key ? ' open' : ''}`}>
                        <button className="lp-faq-q lp-faq-q-sm" onClick={() => setOpenModalFaq(openModalFaq === key ? null : key)}>
                          <span>{item.q}</span>
                          <span className="lp-faq-arrow">{openModalFaq === key ? '−' : '+'}</span>
                        </button>
                        {openModalFaq === key && <div className="lp-faq-a lp-faq-a-sm">{item.a}</div>}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── AUTH MODAL (без змін) ── */}
      {showAuthModal && (
        <div
          style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '16px'
          }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowAuthModal(false); }}
        >
          <div style={{
            backgroundColor: '#fff', borderRadius: '16px', maxWidth: '420px', width: '100%',
            boxShadow: '0 25px 50px rgba(0,0,0,0.15)', overflow: 'hidden'
          }}>
            <div style={{ padding: '24px 24px 0', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: '600', color: '#163248', marginBottom: '4px', fontFamily: "'Roboto', sans-serif" }}>
                {authMode === 'login' ? 'Вхід в LIHTAR' : 'Реєстрація'}
              </div>
              <p style={{ fontSize: '13px', color: '#9ca3af' }}>
                {authMode === 'login' ? 'Оберіть спосіб входу' : 'Створіть акаунт'}
              </p>
            </div>
            <div style={{ padding: '20px 24px 24px' }}>
              {authSuccess ? (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <p style={{ fontSize: '14px', color: '#374151', lineHeight: '1.5' }}>{authSuccess}</p>
                  <button
                    onClick={() => { setAuthMode('login'); setAuthSuccess(''); }}
                    style={{ marginTop: '16px', padding: '10px 24px', backgroundColor: '#163248', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}
                  >
                    Перейти до входу
                  </button>
                </div>
              ) : (
                <>
                  <button
                    onClick={handleGoogleLogin}
                    disabled={loginLoading}
                    style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '12px', border: '1px solid #e5e7eb', borderRadius: '10px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#163248', marginBottom: '8px' }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24">
                      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    {loginLoading ? 'Вхід...' : 'Увійти через Google'}
                  </button>
                  <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '10px 12px', marginBottom: '16px', fontSize: '12px', color: '#166534', lineHeight: '1.5' }}>
                    <strong>Google акаунт</strong> — файли зберігаються на вашому Google Диску. Без обмежень розміру та кількості
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '0 0 16px' }}>
                    <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e7eb' }}></div>
                    <span style={{ fontSize: '12px', color: '#9ca3af' }}>або через email</span>
                    <div style={{ flex: 1, height: '1px', backgroundColor: '#e5e7eb' }}></div>
                  </div>
                  <div style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a', borderRadius: '8px', padding: '10px 12px', marginBottom: '16px', fontSize: '12px', color: '#92400e', lineHeight: '1.5' }}>
                    <strong>Email акаунт</strong> — файли зберігаються на сервері. До 10 файлів на звіт (до 2 МБ кожний). Документи об'єкту — до 10 МБ
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
                      style={{ width: '100%', padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '16px', color: '#163248', backgroundColor: '#fff', boxSizing: 'border-box', outline: 'none' }}
                      onFocus={(e) => e.target.style.borderColor = '#163248'} onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Пароль"
                      onKeyDown={(e) => { if (e.key === 'Enter' && authMode === 'login') handleEmailLogin(); }}
                      style={{ width: '100%', padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '16px', color: '#163248', backgroundColor: '#fff', boxSizing: 'border-box', outline: 'none' }}
                      onFocus={(e) => e.target.style.borderColor = '#163248'} onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                    {authMode === 'register' && (
                      <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Підтвердіть пароль"
                        onKeyDown={(e) => { if (e.key === 'Enter') handleEmailRegister(); }}
                        style={{ width: '100%', padding: '12px 14px', border: '1px solid #e5e7eb', borderRadius: '10px', fontSize: '16px', color: '#163248', backgroundColor: '#fff', boxSizing: 'border-box', outline: 'none' }}
                        onFocus={(e) => e.target.style.borderColor = '#163248'} onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      />
                    )}
                    {authError && <p style={{ fontSize: '13px', color: '#ef4444', textAlign: 'center', margin: 0 }}>{authError}</p>}
                    <button
                      onClick={authMode === 'login' ? handleEmailLogin : handleEmailRegister}
                      disabled={emailLoading}
                      style={{ width: '100%', padding: '12px', backgroundColor: '#163248', color: '#fff', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '500', cursor: emailLoading ? 'wait' : 'pointer', opacity: emailLoading ? 0.6 : 1 }}
                    >
                      {emailLoading ? '...' : authMode === 'login' ? 'Увійти' : 'Зареєструватись'}
                    </button>
                  </div>
                  <p style={{ fontSize: '13px', color: '#9ca3af', textAlign: 'center', marginTop: '16px' }}>
                    {authMode === 'login' ? (
                      <>Немає акаунту? <span onClick={() => { setAuthMode('register'); setAuthError(''); }} style={{ color: '#163248', fontWeight: '500', cursor: 'pointer', textDecoration: 'underline' }}>Зареєструватись</span></>
                    ) : (
                      <>Вже є акаунт? <span onClick={() => { setAuthMode('login'); setAuthError(''); }} style={{ color: '#163248', fontWeight: '500', cursor: 'pointer', textDecoration: 'underline' }}>Увійти</span></>
                    )}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Калькулятор модалка */}
      {showCalc && (
        <React.Suspense fallback={null}>
          <MaterialCalculator
            isOpen={true}
            onClose={() => setShowCalc(false)}
            user={null}
            isGuest={true}
            onGuestRegister={() => { setShowCalc(false); setShowAuthModal(true); }}
            onCreateOrder={() => {}}
          />
        </React.Suspense>
      )}
    </div>
  );
};

// ── STYLES ────────────────────────────────────────────────────────────────────

const STYLES = `
  /* Header */
  .lp-hdr {
    position: sticky; top: 0; z-index: 200;
    background: #163248; height: 56px;
    display: flex; align-items: center;
  }
  .lp-hdr-inner {
    max-width: 1200px; width: 100%; margin: 0 auto;
    padding: 0 24px; display: flex; align-items: center; justify-content: space-between;
  }
  .lp-logo {
    font-family: 'Archivo Black', sans-serif;
    font-size: 20px; color: #fff; letter-spacing: 1.5px;
  }
  .lp-nav { display: flex; align-items: center; gap: 2px; }
  .lp-nav-btn {
    color: #c8dde6; font-size: 14px; font-weight: 500;
    background: transparent; border: none; cursor: pointer;
    padding: 8px 14px; border-radius: 6px;
    transition: background .15s, color .15s; font-family: inherit;
  }
  .lp-nav-btn:hover { color: #fff; background: rgba(255,255,255,.08); }
  .lp-login-btn {
    background: #fff; color: #163248; font-weight: 700;
    padding: 7px 20px; border-radius: 6px; border: none;
    font-size: 14px; cursor: pointer; font-family: inherit;
    transition: opacity .15s;
  }
  .lp-login-btn:hover { opacity: .9; }

  /* Hero */
  .lp-hero {
    background: linear-gradient(180deg, #f8f9fa 0%, #fff 100%);
    padding: 80px 24px 64px;
  }
  .lp-hero-inner {
    max-width: 1200px; margin: 0 auto; text-align: center;
  }
  .lp-badge {
    display: inline-block;
    background: #fff7ed; color: #f97316;
    font-size: 11px; font-weight: 700; letter-spacing: .8px;
    text-transform: uppercase; padding: 5px 14px; border-radius: 100px;
    margin-bottom: 24px; border: 1px solid #fed7aa;
  }
  .lp-h1 {
    font-size: 48px; line-height: 1.15; color: #163248;
    font-weight: 700; margin: 0 auto 20px; max-width: 720px;
  }
  .lp-accent { color: #f97316; }
  .lp-hero-sub {
    font-size: 18px; color: #4b5563; line-height: 1.7;
    margin: 0 auto 36px; max-width: 600px;
  }
  .lp-hero-actions { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin-bottom: 16px; }
  .lp-btn-cta {
    background: #f97316; color: #fff; font-weight: 700;
    padding: 14px 32px; border-radius: 8px; border: none;
    font-size: 16px; cursor: pointer; font-family: inherit;
    transition: opacity .2s;
  }
  .lp-btn-cta:hover { opacity: .9; }
  .lp-btn-outline {
    background: #fff; color: #163248;
    border: 1.5px solid #d1d5db;
    padding: 14px 32px; border-radius: 8px;
    font-size: 16px; font-weight: 600; cursor: pointer;
    font-family: inherit; text-decoration: none;
    display: inline-block;
    transition: border-color .2s;
    box-sizing: border-box;
  }
  .lp-btn-outline:hover { border-color: #163248; }
  .lp-hero-note { font-size: 12px; color: #9ca3af; }
  .lp-hero-screenshot {
    margin: 48px auto 0; max-width: 1000px; width: 100%;
    border-radius: 12px; box-shadow: 0 16px 60px rgba(22,50,72,.15);
    border: 1px solid #e5e7eb; display: block;
  }

  /* Promo Banner */
  /* Sections */
  .lp-section { padding: 80px 24px; }
  .lp-section-gray { background: #f8f9fa; }
  .lp-inner { max-width: 1200px; margin: 0 auto; }
  .lp-section-label {
    font-size: 11px; font-weight: 700; letter-spacing: 1.2px;
    text-transform: uppercase; color: #f97316; margin-bottom: 12px;
    text-align: center;
  }
  .lp-h2 {
    font-size: 30px; font-weight: 700; color: #163248;
    margin: 0 0 40px; line-height: 1.25;
    text-align: center;
  }

  /* Features */
  .lp-h2-sub {
    font-size: 16px; color: #6b7280; text-align: center;
    margin: 0 auto 48px; line-height: 1.6; max-width: 600px;
  }
  .lp-feat-block {
    display: grid; grid-template-columns: 1fr 1.2fr; gap: 48px;
    align-items: center; margin-bottom: 80px;
  }
  .lp-feat-block.reverse { direction: rtl; }
  .lp-feat-block.reverse > * { direction: ltr; }
  .lp-feat-block:last-child { margin-bottom: 0; }
  .lp-feat-tag {
    display: inline-block; background: #fff7ed; color: #f97316;
    font-size: 10px; font-weight: 700; letter-spacing: 1px;
    text-transform: uppercase; padding: 4px 10px; border-radius: 4px;
    margin-bottom: 14px; border: 1px solid #fed7aa;
  }
  .lp-feat-text {}
  .lp-feat-title {
    font-size: 26px; font-weight: 700; color: #163248; margin: 0 0 12px; line-height: 1.3;
  }
  .lp-feat-desc {
    font-size: 15px; color: #555; line-height: 1.7; margin: 0 0 20px;
  }
  .lp-feat-list {
    list-style: none; padding: 0; margin: 0;
    display: flex; flex-direction: column; gap: 8px;
  }
  .lp-feat-list li {
    font-size: 14px; color: #374151; padding-left: 20px; position: relative; line-height: 1.5;
  }
  .lp-feat-list li::before {
    content: ''; position: absolute; left: 0; top: 7px;
    width: 7px; height: 7px; border-radius: 50%; background: #f97316;
  }
  .lp-feat-img {
    border-radius: 12px; box-shadow: 0 8px 40px rgba(22,50,72,.1);
    border: 1px solid #e5e7eb; width: 100%; display: block;
  }

  /* Calculator CTA */
  .lp-calc-cta {
    max-width: 680px; margin: 0 auto; text-align: center;
    background: #fff; border-radius: 20px;
    border: 1.5px solid #e5e7eb;
    padding: 48px 40px;
    box-shadow: 0 4px 24px rgba(22,50,72,.06);
  }
  .lp-calc-cta-types {
    display: flex; flex-wrap: wrap; gap: 10px;
    justify-content: center; margin-bottom: 36px;
  }
  .lp-calc-tag {
    background: #f8f9fa; border: 1px solid #e5e7eb;
    color: #374151; font-size: 13px; font-weight: 500;
    padding: 7px 16px; border-radius: 100px;
  }
  .lp-calc-main-btn {
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 16px; padding: 15px 40px; border-radius: 10px;
    text-decoration: none; margin-bottom: 14px;
  }
  .lp-calc-hint { font-size: 12px; color: #9ca3af; }

  /* Calculator placeholder (unused) */
  .lp-calc-placeholder {
    max-width: 800px; margin: 0 auto;
    background: #f8f9fa; border-radius: 16px; border: 1px solid #e5e7eb;
    padding: 40px; text-align: center;
  }



  /* Pricing */
  .lp-pricing-grid {
    display: grid; grid-template-columns: 1fr 1fr; gap: 24px;
    max-width: 800px; margin: 0 auto;
  }
  .lp-price-card {
    background: #fff; border-radius: 16px;
    border: 1px solid #e5e7eb; padding: 32px 28px;
    display: flex; flex-direction: column;
  }
  .lp-price-card.lp-price-pro {
    border-color: #163248; border-width: 2px; position: relative;
  }
  .lp-pro-badge {
    position: absolute; top: 18px; right: 18px;
    background: #f97316; color: #fff; font-size: 11px; font-weight: 700;
    padding: 3px 10px; border-radius: 4px;
  }
  .lp-price-name {
    font-size: 12px; font-weight: 700; color: #9ca3af;
    letter-spacing: 1px; text-transform: uppercase; margin-bottom: 6px;
  }
  .lp-price-amount {
    font-size: 36px; font-weight: 700; color: #163248; line-height: 1; margin-bottom: 4px;
  }
  .lp-price-amount span { font-size: 15px; font-weight: 500; color: #9ca3af; }
  .lp-price-note { font-size: 12px; color: #bbb; margin-bottom: 24px; }
  .lp-price-list {
    list-style: none; padding: 0; margin: 0 0 24px;
    display: flex; flex-direction: column; gap: 9px; flex: 1;
  }
  .lp-price-list li {
    font-size: 13px; color: #374151; padding-left: 18px; position: relative;
  }
  .lp-price-list li::before {
    content: ''; position: absolute; left: 0; top: 5px;
    width: 6px; height: 6px; border-radius: 50%; background: #c8dde6;
  }
  .lp-price-list li.lp-pro-item::before { background: #f97316; }
  .lp-price-list li.lp-locked { color: #bbb; }
  .lp-price-list li.lp-locked::before { background: #e5e7eb; }
  .lp-btn-outline-navy {
    width: 100%; padding: 11px; border-radius: 8px;
    border: 1.5px solid #163248; background: transparent;
    color: #163248; font-weight: 600; font-size: 14px;
    cursor: pointer; font-family: inherit; transition: background .15s;
  }
  .lp-btn-outline-navy:hover { background: #f0f4f8; }
  .lp-btn-navy {
    width: 100%; padding: 11px; border-radius: 8px;
    border: none; background: #163248;
    color: #fff; font-weight: 700; font-size: 14px;
    cursor: pointer; font-family: inherit; transition: opacity .15s;
  }
  .lp-btn-navy:hover { opacity: .9; }

  /* FAQ */
  .lp-faq-list { max-width: 760px; margin: 0 auto 0; }
  .lp-faq-item { border-bottom: 1px solid #f0f0f0; }
  .lp-faq-q {
    width: 100%; text-align: left; padding: 17px 0;
    background: transparent; border: none; cursor: pointer;
    font-family: inherit; font-size: 15px; font-weight: 600;
    color: #163248; display: flex; justify-content: space-between; align-items: center; gap: 16px;
  }
  .lp-faq-q-sm { font-size: 14px; padding: 13px 0; }
  .lp-faq-arrow { color: #f97316; font-size: 18px; flex-shrink: 0; font-weight: 400; }
  .lp-faq-a {
    font-size: 14px; color: #555; line-height: 1.7; padding-bottom: 16px;
  }
  .lp-faq-a-sm { font-size: 13px; padding-bottom: 12px; }

  /* CTA Final */
  .lp-cta-final {
    background: linear-gradient(135deg, #163248 0%, #1e4a6e 100%);
    padding: 80px 24px; text-align: center;
  }
  .lp-cta-final h2 {
    font-size: 32px; font-weight: 700; color: #fff; margin: 0 0 16px;
  }
  .lp-cta-final p {
    font-size: 16px; color: #c8dde6; margin: 0 0 32px;
  }
  .lp-btn-cta-white {
    background: #fff; color: #163248; font-weight: 700;
    padding: 14px 36px; border-radius: 8px; border: none;
    font-size: 16px; cursor: pointer; font-family: inherit;
    transition: opacity .15s;
  }
  .lp-btn-cta-white:hover { opacity: .9; }

  /* Footer */
  .lp-footer { background: #0e2233; padding: 36px 24px; }
  .lp-footer-inner {
    max-width: 1200px; margin: 0 auto;
    display: flex; align-items: center; flex-wrap: wrap; gap: 16px; justify-content: space-between;
  }
  .lp-footer-logo {
    font-family: 'Archivo Black', sans-serif;
    font-size: 18px; color: #fff; letter-spacing: 1.5px;
  }
  .lp-footer-links { display: flex; gap: 20px; flex-wrap: wrap; align-items: center; }
  .lp-footer-links a { color: #6b8a9e; font-size: 13px; text-decoration: none; }
  .lp-footer-links a:hover { color: #9bb5c9; }
  .lp-footer-faq-btn {
    background: transparent; border: none; color: #6b8a9e;
    font-size: 13px; cursor: pointer; font-family: inherit; padding: 0;
  }
  .lp-footer-faq-btn:hover { color: #9bb5c9; }
  .lp-footer-copy { color: #4a6070; font-size: 12px; width: 100%; text-align: center; }

  /* FAQ Modal */
  .lp-modal-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,.5);
    z-index: 500; display: flex; align-items: center; justify-content: center; padding: 16px;
  }
  .lp-modal-box {
    background: #fff; border-radius: 16px;
    width: 100%; max-width: 720px; max-height: 85vh;
    display: flex; flex-direction: column;
    box-shadow: 0 32px 80px rgba(0,0,0,.2);
  }
  .lp-modal-hdr {
    padding: 18px 24px; border-bottom: 1px solid #f0f0f0;
    display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
  }
  .lp-modal-close {
    background: transparent; border: none; cursor: pointer;
    color: #888; font-size: 18px; padding: 4px 8px; font-family: inherit;
  }
  .lp-modal-body { overflow-y: auto; padding: 0 24px 24px; }
  .lp-modal-cat {
    font-size: 11px; font-weight: 700; letter-spacing: 1px;
    text-transform: uppercase; color: #f97316; padding: 20px 0 6px;
  }

  /* Responsive */
  @media (max-width: 900px) {
    .lp-hero-screenshot { margin-top: 32px; }
    .lp-feat-block, .lp-feat-block.reverse { grid-template-columns: 1fr; gap: 24px; direction: ltr; }
    .lp-feat-block { margin-bottom: 48px; }
    .lp-pricing-grid { grid-template-columns: 1fr; max-width: 420px; }
  }
  @media (max-width: 600px) {
    .lp-hdr-inner { padding: 0 16px; }
    .lp-nav { display: none; }
    .lp-hero { padding: 48px 16px 40px; }
    .lp-h1 { font-size: 28px; }
    .lp-section { padding: 56px 16px; }
    .lp-btn-cta, .lp-btn-outline { width: 100%; text-align: center; }
    .lp-hero-actions { flex-direction: column; }
    .lp-cta-final { padding: 56px 16px; }
    .lp-cta-final h2 { font-size: 24px; }
  }
`;

export default LandingPage;
